import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        training: '=',
        rooms: '=',
        trainers: '=',
        trainingCompanies: '=',
        participants: '=',
        occurrence: '=',
        canManageOccurrences: '=',
        reload: '&',
        trainingTimesWithParticipants: '='
    },
    template: `
    <div class="alert alert-plain" ng-if="!vm.training.times.length">
        <h3>{{ 'general.This table has no content yet' | translate }}</h3>
        <p>{{ 'general.Please add some content' | translate }}</p>
    </div>
    <div class="row" ng-repeat="time in vm.training.times">
        <form-row ng-if="time.errors" error="error" ng-repeat="error in time.errors">
            <form-row-error></form-row-error>
        </form-row>
    </div>
    <div class="well" ng-if="vm.training.times.length" >
        <table datatable="ng" dt-options="vm.DATATABLES"  class="data01" ng-style="{'table-layout': 'fixed'}">
            <colgroup>
                <col width="10%"/>
                <col width="10%"/>
                <col width="20%"/>
                <col width="20%"/>
                <col width="15%"/>
                <col width="15%"/>
                <col width="10%"/>
            </colgroup>
            <thead>
                <tr>
                    <th data-priority="1" ng-if="vm.isClassRoomTraining()">{{ 'occurrence.From' | translate }}</th>
                    <th data-priority="1" ng-if="!vm.isClassRoomTraining()">{{ 'occurrence.Accessible from' | translate }}</th>
                    <th ng-if="vm.isClassRoomTraining()">{{ 'occurrence.To' | translate }}</th>
                    <th ng-if="!vm.isClassRoomTraining()">{{ 'occurrence.Deadline' | translate }}</th>
                    <th>{{ 'occurrence.Trainers' | translate }}</th>
                    <th ng-if="vm.isWebinarTraining()"></th>
                    <th ng-if="!vm.isWebinarTraining()">{{ 'occurrence.Room' | translate }}</th>
                    <th ng-if="vm.isWebinarTraining()"></th>
                    <th ng-if="!vm.isWebinarTraining()">{{ 'occurrence.Room capacity' | translate }}</th>
                    <th>{{ 'occurrence.Training time capacity' | translate }}</th>
                    <th class="none dt-hide"></th>
                    <th class="all">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="(index, time) in vm.training.times" ng-class="{ status01: time.errors }">
                    <td>
                        <span ng-if="time.timeStart">{{ vm.MomentService.format(time.timeStart) }}</span>
                    </td>
                    <td>
                        <span>{{ vm.formatDeadline(time.timeEnd) }}</span>
                    </td>
                    <td>{{ vm.getTrainers(time) }}</td>
                    <td>{{ vm.getRoom(time.roomId).name }}</td>
                    <td>
                        <span ng-if="time.roomId">
                            {{ time.participantCount }}/{{ vm.getRoom(time.roomId).capacity }}
                        </span>
                    </td>
                    <td>
                        <span>
                            {{ vm.showTrainingTimeCapacity(time) }}
                        </span>
                    </td>
                    <td>
                        <div ng-non-bindable>
                            <courses-courses-edit-occurrence-steps-schedule-training-times-participants training="vm.training"/>
                        </div>
                    </td>
                    <td class="actions">
                        <a class="btn edit" ng-click="vm.manageTrainingTime(time)">
                            <span ng-if="vm.canManageOccurrences">{{ 'general.Edit' | translate }}</span>
                            <span ng-if="!vm.canManageOccurrences">{{ 'general.View' | translate }}</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    `
})
export default class {
    constructor ($rootScope, lodash, DATATABLES, RoomResource, OccurrenceService, DatatableService,
                 MomentService, COURSE_TRAINING_TYPE_ENUM) {
        this.MomentService = MomentService;
        this.lodash = lodash;
        this.DATATABLES = lodash.merge({}, DATATABLES, DatatableService.getResponsiveOption(([rowIndex]) => {
            const $newScope = $rootScope.$new();
            $newScope.vm = this;
            $newScope.index = rowIndex;
            return $newScope;
        }));
        this.RoomResource = RoomResource;
        this.OccurrenceService = OccurrenceService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
    }

    isClassRoomTraining () {
        return this.training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM;
    }

    isWebinarTraining () {
        return this.training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR;
    }

    isTestTraining () {
        return this.training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST;
    }

    getRoom (id) {
        return this.lodash.find(this.rooms, { id });
    }

    isRoomOverbooked (roomId, participantsCount) {
        return roomId ? this.getRoom(roomId).capacity < participantsCount : false;
    }

    getTrainers (time) {
        const trainers = time.trainerIds.map((id) => {
            const trainer = this.lodash.find(this.trainers, { id: parseInt(id, 10) });
            return trainer ? trainer.displayName : '';
        });

        const trainingCompanies = time.trainingCompanyIds.map((id) => {
            const company = this.lodash.find(this.trainingCompanies, { id: parseInt(id, 10) });
            return company ? company.name : '';
        });

        const trainersAndCompanies = trainers.concat(trainingCompanies);

        return time.trainingCompanyTrainer ?
            trainersAndCompanies.concat([time.trainingCompanyTrainer]).join(', ') :
            trainersAndCompanies.join(', ');
    }

    manageTrainingTime (time) {
        return this.OccurrenceService.manageTrainingTime(
            this.occurrence, this.canManageOccurrences, this.rooms, this.trainers,
            this.trainingCompanies, this.training, time
        ).then((updatedTraining) => {
            this.RoomResource.query().$promise.then(rooms => {
                // in case training time was saved with new room
                this.rooms = rooms;
                this.training.times = updatedTraining.times;
            });
        });
    }

    formatDeadline (time) {
        if (!this.isClassRoomTraining() && !this.isTestTraining) {
            return this.MomentService.formatDate(time);
        }
        return this.MomentService.format(time);
    }

    showTrainingTimeCapacity (time) {
        if (time.hasCapacity) {
            return `${time.participantCount}/${time.capacity}`;
        }

        if (this.occurrence.trainingTimeCapacity) {
            return `${time.participantCount}/${this.occurrence.trainingTimeCapacity}`;
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/schedule/trainingTimes/index.js